import { render, staticRenderFns } from "./QuestionMultiselect.vue?vue&type=template&id=10493fdc&"
import script from "./QuestionMultiselect.vue?vue&type=script&lang=js&"
export * from "./QuestionMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports